/* Potvorky – cart drawer countdown timer.
   The whole .drawer__inner (including this markup) is replaced via innerHTML on every
   cart change (see CartDrawer.renderContents in cart-drawer.js), which means any inline
   <script> here would only ever run once and never again — so this re-initializes on
   Dawn's own cart-update pub/sub event instead of relying on a single DOMContentLoaded run. */
(function () {
  'use strict';

  var timerInterval = null;

  function initCartTimer() {
    var el = document.querySelector('[data-pv-cart-timer]');
    if (!el) {
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
      return;
    }

    var clockEl = el.querySelector('[data-pv-timer-clock]');
    var storageKey = 'pvCartTimerEnd';
    var totalSeconds = parseInt(el.dataset.seconds, 10) || 300;
    var endTime = parseInt(sessionStorage.getItem(storageKey), 10);
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + totalSeconds * 1000;
      sessionStorage.setItem(storageKey, endTime);
    }

    function render() {
      var currentEl = document.querySelector('[data-pv-timer-clock]');
      if (!currentEl) {
        clearInterval(timerInterval);
        timerInterval = null;
        return;
      }
      var remaining = Math.max(0, Math.round((endTime - Date.now()) / 1000));
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      currentEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (remaining <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        sessionStorage.removeItem(storageKey);
      }
    }

    if (timerInterval) clearInterval(timerInterval);
    render();
    timerInterval = setInterval(render, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartTimer();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(initCartTimer);
      });
    }
  });
})();
